// ================================================================================
// wp-block-site-menu-button.js
// ハンバーガーメニューのスクリプトファイル
// ================================================================================

document.addEventListener('DOMContentLoaded', () => {

	const dropDownButton = document.getElementById('js-mobile-menu');
	const menuOpenTarget = document.querySelector('body');
	const navLinks = document.querySelectorAll('.wp-pattern-navigation a');

	if ( dropDownButton ) {
		dropDownButton.addEventListener('click', function() {
			dropDownButton.classList.toggle('is-close');
			menuOpenTarget.classList.toggle('is-menu-open');
		} );

		// ナビゲーションリンククリックで閉じる
		navLinks.forEach(link => {
			link.addEventListener('click', () => {
				// すでに開いている場合のみ閉じる
				if (menuOpenTarget.classList.contains('is-menu-open')) {
					dropDownButton.classList.remove('is-close');
					menuOpenTarget.classList.remove('is-menu-open');
				}
			});
		} );
	}

} );
